import React from 'react'
import { ShiftCard } from './ShiftCard'
import { ShiftWithDuty, EventDetailMetaProps } from '../data/types'


type Props = {
    shifts: ShiftWithDuty[]
    meta: EventDetailMetaProps
    formatTime: (timeStr: string | null | undefined) => string
    onEdit?: (shift: ShiftWithDuty) => void
    onDelete?: (shift: ShiftWithDuty) => void
    onAssign?: (shift: ShiftWithDuty) => void
    onView?: (shift: ShiftWithDuty) => void
    onDuplicate?: (shift: ShiftWithDuty) => void
    onCopyAllocations?: (shift: ShiftWithDuty) => void
    canEdit?: (shift: ShiftWithDuty) => boolean
    canDelete?: (shift: ShiftWithDuty) => boolean
    canView?: (shift: ShiftWithDuty) => boolean
    canAssign?: (shift: ShiftWithDuty) => boolean
    canDuplicate?: (shift: ShiftWithDuty) => boolean
    canCopyAllocations?: (shift: ShiftWithDuty) => boolean
    areaShiftsVisible?: boolean
    eventShiftsVisible?: boolean
    showVisibility?: boolean
}

export const ShiftsList = (props: Props) => {
    const { shifts, meta, formatTime, onEdit, onDelete, onAssign, onView, onDuplicate, onCopyAllocations, canEdit, canDelete, canView, canAssign, canDuplicate, canCopyAllocations, areaShiftsVisible, eventShiftsVisible, showVisibility } = props

    if (!shifts || shifts.length === 0) {
        return (
            <p className="text-gray-500 dark:text-gray-400 text-center py-4">
                {meta.noShiftsMessage}
            </p>
        )
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {shifts.map((shift) => (
                <ShiftCard
                    key={shift.id}
                    shift={shift}
                    meta={meta}
                    formatTime={formatTime}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onAssign={onAssign}
                    onView={onView}
                    onDuplicate={onDuplicate}
                    onCopyAllocations={onCopyAllocations}
                    canEdit={canEdit ? canEdit(shift) : false}
                    canDelete={canDelete ? canDelete(shift) : false}
                    canView={canView ? canView(shift) : false}
                    canAssign={canAssign ? canAssign(shift) : false}
                    canDuplicate={canDuplicate ? canDuplicate(shift) : false}
                    canCopyAllocations={canCopyAllocations ? canCopyAllocations(shift) : false}
                    areaShiftsVisible={areaShiftsVisible}
                    eventShiftsVisible={eventShiftsVisible}
                    showVisibility={showVisibility}
                />
            ))}
        </div>
    )
}
